module.exports = __webpack_public_path__ + "img/bonus_symbol_4.6f8793ee.png";